export type DatePickerType = 'nextaction' | 'expectedclosing' | 'none'

export const US_DATE_FORMAT = 'MM/dd/yyyy'
export const CAN_DATE_FORMAT = 'yyyy/MM/dd'

export const US_DATE_EMPTY_PLACEHOLDER = '- - / - - / - - - -'
export const CAN_DATE_EMPTY_PLACEHOLDER = '- - - - / - - / - -'
